"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_observable_1 = require("redux-observable");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var connected_react_router_1 = require("connected-react-router");
var fileUploadModal_1 = require("actions/fileUploadModal");
var epics_1 = require("utils/upload/epics");
/** Handler for single file upload (called by FILEUPLOAD_REQUEST epic) */
var epics = (0, epics_1.createEpics)('@sok/web/fileupload', function (state) { return state.fileUploadModal; });
function fileUploadDone(action$, store, _fetchOptions) {
    var successAction = '@sok/web/fileupload/FILEUPLOAD_FILE_SUCCESS';
    var failureAction = '@sok/web/fileupload/FILEUPLOAD_FILE_FAILURE';
    return action$.pipe((0, operators_1.filter)(function (action) { return action.type === successAction || action.type === failureAction; }), (0, operators_1.mergeMap)(function () {
        var state = store.value;
        var filesInUploading = state.fileUploadModal.uploadedFiles;
        var itemsSoFar = Object.values(filesInUploading).filter(function (i) { return i.status === 'UPLOADED'; });
        var allDone = itemsSoFar.length ===
            state.fileUploadModal.currentUploadStatus.totalFiles;
        // Upload modal
        if (allDone) {
            // If upload modal is open then we can set upload progress done and redirect user to metaeditor
            if (state.fileUploadModal.modalState.isOpen) {
                var pathname = state.fileUploadModal.baseUrl ||
                    (state.router.location && state.router.location.pathname);
                return (0, rxjs_1.of)(fileUploadModal_1.default.fileuploadDone(), (0, connected_react_router_1.push)("".concat(pathname, "/metadata/").concat(state.fileUploadModal.currentUploadStatus.session)));
            }
        }
        return (0, rxjs_1.empty)();
    }));
}
exports.default = (0, redux_observable_1.combineEpics)(epics.checkDuplicateFolder, epics.initFileUpload, epics.handleFileUpload, epics.cancelUploadSession, fileUploadDone);
